import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import API from "../../Network/API";
import TimeZone from "../../CustomHooks/TimeZone";
import MeetingShare from "./MeetingShare";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function AddMeetingSchedule(props) {
  const [modalDialog, setModalDialog] = useState(false);

  const toggleModal = () => {
    setModalDialog(!modalDialog)
  };
  const {t} = useTranslation()
  const [check_box,setCheckbox]=useState(false)
  const [waitingRoom, setWaitingRoom] = useState(false);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(null);
  const [date, setDate] = useState(null);
  const [time_zone, setTimeZone] = useState('Europe/London');
  const [time, setTime] = useState(null);
  const [duration, setDuration] = useState(60);
  const [password, setPassword] = useState('');
  const [note, setNote] = useState('');
  const [sendToShareData, setSendToShareData] = useState('');
  // const [data] = useFetch("https://jsonplaceholder.typicode.com/todos");
  const fileObj = [];
  const fileArray = [];
  const fileArrayAnother = [];
  const [file, setFile] = useState([]);
  const [timezonename, setTimezoneText] = useState('');

  const usert_timez = useSelector((state) => state.timeZoneReducer)

  const getCurrentTimezone = () => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setTimezoneText(userTimezone);
  };

  const handleSubmit = event => {
    event.preventDefault();

    if (typeof title === null) {
      toast.error('Please add title.');
      return false;
    }
    if (typeof time_zone === null) {
      toast.error('Please add time_zone.');
      return false;
    }
    const fd = new FormData();
    fd.append('title', title);
    fd.append('date', date);
    fd.append('time_zone', time_zone);
    fd.append('time', time);
    fd.append('duration', duration);
    fd.append('note', note);
    fd.append('password', null);
    if(event.target.is_recurring.checked){
      fd.append('is_repeated', 1);

      if(event.target.recurring_type.value==""){
        alert("Please select recurrence type");
        return;
      }
      fd.append('recurring_type', event.target.recurring_type.value);

    }else{
      fd.append('is_repeated', 0);
      fd.append('recurring_type', 0);
    }
    
    fd.append('is_waiting_room_enabled', waitingRoom ? 1 : 0);
    

    setLoading(true);
    if (fileObj.length > 0) {
      for (var i = 0; i < fileObj.length; i++) {
        fd.append('img', fileObj[i], fileObj[i].name);
      }
    }

    API.post('/v3/myScheduleCreate', fd).then(response => {
      setLoading(false);
      if (response.data.success === true) {
        props.handleShowB()
        setSendToShareData(response.data.data)
        toggleModal()
      }
    }).catch((error) => {
      setLoading(false);
      toast.error(error.response.data.sms);
    });
  }

  const uploadHandler = (e) => {
    fileObj.pop();
    fileObj.push(e.target.files[0])

  }

  useEffect(() => {
    getCurrentTimezone();
  }, []);


  return (
    <>
      <Modal
        isOpen={props.isModalVisible}
        size=""
        toggle={props.handleShowB}
        className={'modal-dialog modal-dialog-scrollable'} backdrop="static"
      >
        <ModalHeader className="border-0 pb-2" toggle={props.handleShowB} id={'staticBackdropLabel'}>
          <h5 className="modal-title fw-bold text-dark mb-0">{t('Schedule Your Meeting')}</h5>
        </ModalHeader>
        <ModalBody className="bg-white px-4 py-0">
          <div className="meeting-schedule-popup">
            <form onSubmit={handleSubmit}>
              <div className="py-3">
                
                {/* TITLE */}
                <div className="mb-4">
                  <label htmlFor="Title" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                    {t('Meeting Title')}
                  </label>
                  <input 
                    type="text" 
                    onChange={(e) => setTitle(e.target.value)} 
                    className="form-control form-control-lg border rounded-3 px-3 shadow-none" 
                    id="Title" 
                    placeholder="E.g., Weekly Sync, Project Review" 
                    style={{fontSize: '15px', color: '#334155'}}
                    required 
                  />
                </div>

                {/* DATE / TIME / DURATION GRID */}
                <div className="row g-3 mb-4">
                  <div className="col-md-4">
                    <label htmlFor="date" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                      {t('Date')}
                    </label>
                    <input 
                      type="date" 
                      onChange={(e) => {
                        setDate(e.target.value);
                        if (e.target.value) {
                          const timeInput = document.getElementById('time');
                          if (timeInput) {
                            timeInput.focus();
                            try { if (typeof timeInput.showPicker === 'function') timeInput.showPicker(); } catch (err) {}
                          }
                        }
                      }} 
                      onBlur={(e) => {
                        if (e.target.value) {
                          const timeInput = document.getElementById('time');
                          if (timeInput && document.activeElement === document.body) timeInput.focus();
                        }
                      }}
                      className="form-control form-control-lg border rounded-3 px-3 shadow-none" 
                      id="date" 
                      style={{fontSize: '15px', color: '#334155'}}
                      required 
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="time" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                      {t('Start Time')}
                    </label>
                    <input 
                      type="time" 
                      onChange={(e) => setTime(e.target.value)} 
                      className="form-control form-control-lg border rounded-3 px-3 shadow-none" 
                      id="time" 
                      style={{fontSize: '15px', color: '#334155'}}
                      required 
                    />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="duration" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                      {t('Duration')}
                    </label>
                    <select
                      id="duration"
                      onChange={(e) => setDuration(e.target.value)}
                      defaultValue={60}
                      className="form-select form-select-lg border rounded-3 px-3 shadow-none"
                      style={{fontSize: '15px', color: '#334155'}}
                      required
                    >
                      <option value={15}>15 minutes</option>
                      <option value={30}>30 minutes</option>
                      <option value={45}>45 minutes</option>
                      <option value={60}>1 hour</option>
                      <option value={90}>1.5 hours</option>
                      <option value={120}>2 hours</option>
                    </select>
                  </div>
                </div>

                {/* TIMEZONE */}
                <div className="row g-3 mb-4">
                  <div className="col-md-12">
                    <label htmlFor="inputState" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                      {t('Time Zone')}
                    </label>
                    <select
                      id="inputState"
                      onChange={(e) => setTimeZone(e.target.value)}
                      defaultValue={usert_timez?.timezone}
                      className="form-select form-select-lg border rounded-3 px-3 shadow-none"
                      style={{fontSize: '15px', color: '#334155'}}
                      required
                    >
                      {TimeZone()?.map((zoneName, index) => (
                        <option
                          key={index}
                          value={zoneName}
                          selected={usert_timez?.timezone === zoneName}
                        >
                          {zoneName}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* TOGGLES: Recurring & Waiting Room */}
                <div className="d-flex flex-column gap-3 mb-4">
                  {/* Recurring Toggle */}
                  <div className="d-flex flex-column border rounded-4 p-3 shadow-sm bg-white" style={{ borderColor: '#e2e8f0' }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h6 className="mb-1 fw-bold text-dark" style={{fontSize: '14px'}}>{t('Recurring Meeting')}</h6>
                        <p className="mb-0 text-secondary" style={{fontSize: '13px'}}>Repeat this meeting daily, weekly, or monthly.</p>
                      </div>
                      <div className="form-check form-switch m-0 pt-0 pe-2">
                        <input 
                          onChange={()=>setCheckbox(!check_box)} 
                          type="checkbox" 
                          role="switch"
                          className="form-check-input m-0" 
                          id="is_recurring" 
                          style={{transform: 'scale(1.2)', cursor: 'pointer', backgroundColor: check_box ? '#1e293b' : '' }}
                        />
                      </div>
                    </div>
                    {check_box && (
                      <div className="mt-3 pt-3 border-top">
                        <label className="form-label fw-semibold text-dark mb-2" style={{fontSize: '13px'}}>How often?</label>
                        <select 
                          className="form-select border rounded-3 px-3 shadow-none" 
                          name="recurring_type" 
                          id="recurring_type"
                          style={{fontSize: '14px', maxWidth: '300px'}}
                        >
                          <option value="">Select frequency</option>
                          <option value={1}>Daily</option>
                          <option value={2}>Weekly</option>
                          <option value={3}>Monthly</option>
                        </select>
                      </div>
                    )}
                  </div>

                  {/* Waiting Room Toggle */}
                  <div className="d-flex align-items-center justify-content-between border rounded-4 p-3 shadow-sm bg-white" style={{ borderColor: '#e2e8f0' }}>
                    <div>
                      <h6 className="mb-1 fw-bold text-dark" style={{fontSize: '14px'}}>{t('Waiting Room')}</h6>
                      <p className="mb-0 text-secondary" style={{fontSize: '13px'}}>
                        Only admit participants after you review them.
                      </p>
                    </div>
                    <div className="form-check form-switch m-0 pt-0 pe-2">
                      <input 
                        onChange={() => setWaitingRoom(!waitingRoom)} 
                        type="checkbox" 
                        role="switch"
                        className="form-check-input m-0 float-end" 
                        id="is_waiting_room_enabled" 
                        checked={waitingRoom}
                        style={{transform: 'scale(1.2)', cursor: 'pointer', backgroundColor: waitingRoom ? '#1e293b' : '' }}
                      />
                    </div>
                  </div>
                </div>

                {/* AGENDA */}
                <div className="mb-4">
                  <label htmlFor="Description" className="form-label fw-semibold text-dark mb-2" style={{fontSize: '14px'}}>
                    {t('Agenda & Notes')}
                  </label>
                  <div className="border rounded-3 overflow-hidden">
                    <ReactQuill
                      theme="snow"
                      id="Description"
                      value={note}
                      onChange={setNote}
                      placeholder="Add meeting agenda, notes, or description (optional)"
                      className="bg-white border-0"
                      style={{ fontSize: '15px' }}
                      modules={{
                        toolbar: [
                          ['bold', 'italic', 'underline'],
                          [{ 'list': 'bullet' }, { 'list': 'ordered' }]
                        ]
                      }}
                      formats={[
                        'bold', 'italic', 'underline', 'list', 'bullet'
                      ]}
                    />
                  </div>
                </div>
              </div>
              
              <ModalFooter className="border-top pt-4 px-4 pb-4">
                <div className="d-flex justify-content-end gap-3 w-100">
                  <button 
                    type="button" 
                    onClick={props.handleShowB}
                    className="btn btn-outline-secondary rounded-pill px-4 py-2 bg-transparent"
                    style={{fontSize: '14px', fontWeight: '600', color: '#64748b', border: 'none'}}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-dark rounded-pill px-4 py-2 text-white shadow-sm d-flex align-items-center"
                    style={{fontSize: '14px', fontWeight: '600', transition: 'all 0.2s', backgroundColor: '#0f172a'}}
                    disabled={loading}
                    onMouseOver={(e) => e.target.style.transform = 'translateY(-1px)'}
                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" style={{width: '14px', height: '14px'}}></span>
                        Scheduling...
                      </>
                    ) : (
                      <>
                        <i className="fa-solid fa-calendar-check me-2" style={{fontSize: '13px', opacity: 0.9}}></i>
                        Schedule Meeting
                      </>
                    )}
                  </button>
                </div>
              </ModalFooter>
            </form>
          </div>
        </ModalBody>

      </Modal>

      <MeetingShare modalVisible={modalDialog} handleShow={() => setModalDialog(false)} shareData={sendToShareData} type={2} />
    </>
  )
}